import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'

import { ROUTE_PATHS } from '../../router/routes'

const MiniGame = React.lazy(() => import('pages/MiniGamePage/MiniGamePage'))

export class MiniGameModule {
  getRoutes() {
    return (
      <Route key={ROUTE_PATHS.MINI_GAMES} path={ROUTE_PATHS.MINI_GAMES}>
        <QueryParamProvider ReactRouterRoute={Route}>
          <Switch>
            <Route key={ROUTE_PATHS.MINI_GAMES} path={ROUTE_PATHS.MINI_GAMES} component={MiniGame} />
          </Switch>
        </QueryParamProvider>
      </Route>
    )
  }
}
